export const CONST = {
  FORMAT: {
    PORTRAIT: 0,
    LANDSCAPE: 1,
  },
  PARAMS: {
    PREVIEW_VRM: 'previewVRM',
  },
  ADMIN_STATUS: {
    ACTIVE: 1,
    INACTIVE: 2,
  },
};
